// Kayıt bittikten sonra kullanıcıyı uygulamaya geçiren düğme(ler).
//
// NEDEN: kayıt sonrası web giriş sayfasına yönlendirilen kişi orada web girişi
// için çıkan QR kodu görüp ne yapacağını anlamıyordu. Yeni akışta üye uygulamaya
// telefon numarasıyla girer; bu bileşen onu cihazına göre doğru yere götürür.
//
//  - Android: uygulama yüklüyse açar, değilse Play Store'a gider (tek düğme).
//    Chrome'un intent:// bağlantısı yüklü olmayan uygulamada fallback adrese gider.
//  - iPhone/iPad: App Store sayfası. Safari uygulamanın yüklü olup olmadığını
//    sessizce anlamaya izin vermiyor (denersek "adres geçersiz" hatası çıkar);
//    uygulama yüklüyse App Store o sayfada zaten "Aç" düğmesi gösteriyor.
//  - Bilgisayar: iki mağaza düğmesi. QR bilerek yok (web girişindeki QR ile karışıyordu).
import React from "react";
import { Smartphone } from "lucide-react";

const PAKET = "com.workience.universalteam";
const PLAY_STORE = `https://play.google.com/store/apps/details?id=${PAKET}`;
const APP_STORE = "https://apps.apple.com/tr/app/nm-universal-team/id6737522734?l=tr";
// utmobil://ac: uygulama "önce giriş yapın" uyarısı göstermeden açılır (main.dart _handleDeepLink)
const ANDROID_AC = `intent://ac#Intent;scheme=utmobil;package=${PAKET};S.browser_fallback_url=${encodeURIComponent(PLAY_STORE)};end`;

export function cihazTuru() {
  if (typeof navigator === "undefined") return "masaustu";
  const ua = navigator.userAgent || "";
  if (/Android/i.test(ua)) return "android";
  // iPadOS 13+ kendini Mac olarak tanıtıyor; dokunmatik olmasından ayırt edilir
  if (/iPhone|iPad|iPod/i.test(ua) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) {
    return "ios";
  }
  return "masaustu";
}

const anaDugme = {
  display: "flex", alignItems: "center", justifyContent: "center", gap: "10px",
  width: "100%", padding: "16px", borderRadius: "12px", border: "none",
  background: "linear-gradient(135deg, #10b981 0%, #059669 100%)", color: "#fff",
  fontSize: "16px", fontWeight: 700, textDecoration: "none", cursor: "pointer",
  boxShadow: "0 4px 12px rgba(16,185,129,0.3)",
};
const ikincilDugme = {
  ...anaDugme, background: "#fff", color: "#065f46", border: "2px solid #10b981", boxShadow: "none",
};

export default function UygulamayaGec() {
  const cihaz = cihazTuru();

  if (cihaz === "android") {
    return (
      <div>
        <a href={ANDROID_AC} style={anaDugme} data-testid="uygulamayi-ac">
          <Smartphone size={20} /> Uygulamayı Aç
        </a>
        <p style={{ marginTop: "10px", fontSize: "13px", color: "#64748b", textAlign: "center" }}>
          Uygulama yüklü değilse Google Play açılır.
        </p>
      </div>
    );
  }

  if (cihaz === "ios") {
    return (
      <div>
        <a href={APP_STORE} style={anaDugme} data-testid="app-store">
          <Smartphone size={20} /> Uygulamayı Aç / İndir
        </a>
        <p style={{ marginTop: "10px", fontSize: "13px", color: "#64748b", textAlign: "center" }}>
          App Store açılır; uygulama yüklüyse oradaki &ldquo;Aç&rdquo; düğmesine dokunun.
        </p>
      </div>
    );
  }

  return (
    <div>
      <p style={{ fontSize: "14px", color: "#475569", textAlign: "center", marginBottom: "12px" }}>
        Uygulamayı telefonunuza indirin, telefon numaranız ve şifrenizle giriş yapın:
      </p>
      <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
        <a href={PLAY_STORE} target="_blank" rel="noopener noreferrer" style={{ ...ikincilDugme, flex: "1 1 160px" }} data-testid="play-store">
          Google Play
        </a>
        <a href={APP_STORE} target="_blank" rel="noopener noreferrer" style={{ ...ikincilDugme, flex: "1 1 160px" }} data-testid="app-store">
          App Store
        </a>
      </div>
    </div>
  );
}
